import { Typography } from "antd";
import { formatInTimeZone } from "date-fns-tz";
const { Text } = Typography;
const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const EMPLOYEE_COLUMNS_HEAD = () => {
  return [
    {
      title: "Serial No.",
      dataIndex: "serial_no",
      align: "left",
    },
    {
      title: "User",
      dataIndex: "username",
      align: "left",
    },
    {
      title: "Date & Time",
      dataIndex: "created_at",
      align: "left",
      render: (ele) => {
        if (!ele) return "";
        return formatInTimeZone(ele, timeZone, "MMM dd yyyy hh:mm:ss a");
      },
    },
    {
      title: "Description",
      dataIndex: "log",
      align: "left",
      render: (ele) => {
        return <Text style={{ wordBreak: "break-word" }}>{ele}</Text>;
      },
    },
  ];
};
